import { render } from "./LiftOffStep.vue?vue&type=template&id=5115211d&scoped=true"
import script from "./LiftOffStep.vue?vue&type=script&lang=ts"
export * from "./LiftOffStep.vue?vue&type=script&lang=ts"

import "./LiftOffStep.vue?vue&type=style&index=0&id=5115211d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5115211d"

export default script